import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { IModalConfirmationState } from './state';

export const getters: GetterTree<IModalConfirmationState, IRootState> = {};
